if (typeof Number.isNaN !== 'function') {
  Number.isNaN = isNaN
}
